import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

export const downloadProductTemplate = (type = "xlsx") => {
    let headers = [
        "category",
        "categoryImage",
        "subcategory",
        "subcategoryImage",
        "productName",
        "productImage",
        "description",
        "price",
        "foodType",
        "isTaxable",
        "online",
        "packageCharge",
        "availableTime",
    ];

    try {
        const cached = localStorage.getItem("restaurantDetails");
        if (cached) {
            const parsed = JSON.parse(cached);
            const features = parsed?.restaurant?.features || {};
            if (features.availableTimeManage === false) {
                headers = headers.filter(h => h !== "availableTime");
            }
        }
    } catch (e) {
        console.error("Error reading features from localStorage:", e);
    }

    const worksheet = XLSX.utils.aoa_to_sheet([headers]);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Products");

    let fileType;
    let fileName;

    if (type === "csv") {
        fileType = "text/csv;charset=utf-8;";
        fileName = "product_template.csv";
    } else if (type === "xls") {
        fileType = "application/vnd.ms-excel;charset=utf-8;";
        fileName = "product_template.xls";
    } else {
        fileType =
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
        fileName = "product_template.xlsx";
    }

    const excelBuffer = XLSX.write(workbook, {
        bookType: type,
        type: "array",
    });

    const data = new Blob([excelBuffer], { type: fileType });

    saveAs(data, fileName);
};